export default {
    "关于MANA": "关于MANA",
    "用户协议": "用户协议",
    "免责声明": "免责声明",
    "侵权申诉": "侵权申诉",
    "帮助中心": "帮助中心",
    "联系我们": "联系我们",
    "投稿须知": "投稿须知",
    "常见问题": "常见问题",
    "版权声明": "版权声明",
    "法律责任": "法律责任"
}


// WEBPACK FOOTER //
// ./src/languages/cn/about.js